export default __webpack_public_path__ + "static/media/git-github.bf190d08.jpg";